// extracted by mini-css-extract-plugin
export default {"ChartCardTitleHeading":"Title-module__ChartCardTitleHeading__IFTkcbP"};